"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var operators_1 = require("rxjs/operators");
var lodash_1 = require("lodash");
exports.getProperties = lodash_1.memoize(loadProperties, function () { return 'key'; });
function loadProperties(store) {
    return store
        .select(function (state) { return state && state.properties; })
        .pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.map(function (properties) { return properties.map; }), operators_1.filter(skynet_store_utilities_1.notNil));
}
exports.loadProperties = loadProperties;
//# sourceMappingURL=properties.store.js.map